import React from 'react';
import PropTypes from 'prop-types';
import { FormTextInput } from 'components/form-fields';
import { GridLayout } from 'components/grid';

const defaultObject = {};
const defaultFunction = () => {};

export const contactNameMaxLength = 100;
export const phoneNumberMaxLength = 20;

export function SubmissionContactSection(
    {
        contactName = "",
        phoneNumber = "",
        idPrefix = "feedback",
        errors = defaultObject,
        disabled = false,
        onChange = defaultFunction
    }
) {
    return (
        <GridLayout numberOfColumns={2}>
            <FormTextInput
                id={`${idPrefix}-contact-name`}
                headingText="Contact name"
                value={contactName}
                maxLength={contactNameMaxLength}
                disabled={disabled}
                dangerHelperText={errors.contactName}
                onChange={(event) => onChange("contactName", event.target.value)}
                fill={true}
            />
            <FormTextInput
                id={`${idPrefix}-phone-number`}
                headingText="Phone number"
                value={phoneNumber}
                maxLength={phoneNumberMaxLength}
                disabled={disabled}
                dangerHelperText={errors.phoneNumber}
                onChange={(event) => onChange("phoneNumber", event.target.value)}
                fill={true}
            />
        </GridLayout>
    );
}

SubmissionContactSection.propTypes = {
    contactName: PropTypes.string,
    phoneNumber: PropTypes.string,
    idPrefix: PropTypes.string,
    errors: PropTypes.object,
    disabled: PropTypes.bool,
    onChange: PropTypes.func
};